module.exports = __webpack_public_path__ + "static/img/list3.fcc25dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/JoinUs/img/list3.jpg
// module id = YrhI
// module chunks = 1